class HeroVideo extends HTMLElement {
  connectedCallback() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    this.mediaQuery = window.matchMedia('(min-width: 750px)');
    this.mediaQuery.addEventListener('change', () => this.swap());

    // Erst starten, wenn die Seite geladen ist. Sonst konkurriert das Video mit dem
    // Hero-Poster um Bandbreite, und das Poster ist das LCP-Element.
    const starten = () => {
      const idle = window.requestIdleCallback || ((fn) => setTimeout(fn, 300));
      idle(() => this.swap(), { timeout: 2000 });
    };

    if (document.readyState === 'complete') starten();
    else window.addEventListener('load', starten, { once: true });
  }

  swap() {
    const wanted = this.mediaQuery.matches ? 'desktop' : 'mobile';
    const template =
      this.querySelector(`template[data-video="${wanted}"]`) || this.querySelector('template[data-video]');
    if (!template || template === this.current) return;

    const previous = this.querySelector('video');
    if (previous) previous.remove();

    const video = template.content.firstElementChild.cloneNode(true);
    video.classList.add('hero__video');
    video.setAttribute('aria-hidden', 'true');
    video.tabIndex = -1;

    // Shopify hängt an jedes Video ein automatisch erzeugtes Vorschaubild in Miniaturgröße.
    // Das läge über unserem Hero-Poster, sobald das Video nicht spielt. Weg damit.
    video.removeAttribute('poster');

    // Sichtbar erst, wenn das Video wirklich läuft. Scheitert das Abspielen, etwa im
    // Stromsparmodus von iOS, fliegt es raus und das Hero-Poster bleibt stehen.
    video.addEventListener('playing', () => video.classList.add('hero__video--spielt'), { once: true });

    this.append(video);
    this.current = template;
    video.play().catch(() => {
      video.remove();
      if (this.current === template) this.current = null;
    });
  }
}

customElements.define('hero-video', HeroVideo);
